<script setup lang="ts">
import type { InvestigationCollectionItem } from '@nuxt/content'

const props = defineProps<{
  page: InvestigationCollectionItem
}>()
</script>

<template>
  <div class="flex justify-end">
    <div class="text-xs dark:text-neutral-400 text-neutral-500 border p-2 rounded border-neutral-200 dark:border-neutral-700">
      Gepubliceerd op: <span class="dark:text-neutral-300 text-neutral-800">{{ getDate(props.page.date) }}</span>
    </div>
  </div>
</template>
